import { render } from "./ItemAcreditadoView.vue?vue&type=template&id=4093d190&ts=true"
import script from "./ItemAcreditadoView.vue?vue&type=script&lang=ts"
export * from "./ItemAcreditadoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__